var $resultTable = null;
var $sortLabels = null;
var PRICE_STEP_NUM = 10;
var SIZE_STEP_NUM = 1;
$(document).ready(function() {
	
	$resultTable = $('#yachtResultTable .item');
	$sortLabels = $(".sortselect");
	
	yachtSearchFilter.init();
	yachtSortFilter.init();
	
	yachtSearchFilter.applyFilter();
	
	$( ".filter-tabs" ).tabs();
	
	$("#showFilter").click(function() {
		$('.resultLeft').fadeToggle("fast");
		$(this).toggleClass("openFilter");
		return false;
	});
	$(".pop-btn-ok").click(function() {
		$('.resultLeft,.pop-sorting').hide();
		return false;
	});
});

var yachtList = [];

var yachtSearchFilter = function() {
	
	this.init = function (){
		
		var minPrice = 99999999;
		var maxPrice = 0;
		
		var minSize=9999999;
		var maxSize=0;
		
		var $currency = 'TL';
		$("#yachtResultTable .item").each(function(index, item){
			var $item = $(item);
			var totalPrice = parseFloat($item.data("price"));
			var price = parseFloat($("#dailyPrice_"+index).val());
			var size = parseFloat($item.data("size"));
			
			$currency = $item.data("currency");
			
			if(price < minPrice)
				minPrice = price;
			
			if(price > maxPrice)
				maxPrice = price;
			
			if(size < minSize)
				minSize = size;
			
			if(size > maxSize)
				maxSize = size;
			
			yachtList.push({
				name:$item.data("yachtname"), 
				price : price, 
				currency : $currency,
				$referance : $item,				
				size:size
			});
		});
		
		minPrice = Math.floor(minPrice);
		maxPrice = Math.ceil(maxPrice);
		minSize= Math.floor(minSize);
		maxSize = Math.ceil(maxSize);	
		
		//ensure that difference of min max price is divisible by  PRICE_STEP_NUM. 
		var sliderPriceRangeRemainder = 0;
		if(minPrice != maxPrice){
			sliderPriceRangeRemainder = (maxPrice-minPrice) % PRICE_STEP_NUM;
		} else {
			sliderPriceRangeRemainder = maxPrice % PRICE_STEP_NUM;
		}
		if(sliderPriceRangeRemainder != 0){
			maxPrice = maxPrice + (PRICE_STEP_NUM - sliderPriceRangeRemainder);
		}
		
		//price range implementation
		$("#slider-range1").slider({
			range: true,
			min: minPrice,
			max: maxPrice,
			values: [minPrice, maxPrice],
			step:PRICE_STEP_NUM,
			slide: function(event, ui) {
				$("#filterByPrice").val(ui.values[0] + " " + $currency + " - " + ui.values[1] + " " + $currency);
			}
		});
		$("#slider-range1").slider({change: function(event, ui) {
			applyFilter();
		}});
		$("#filterByPrice").val($("#slider-range1").slider("values", 0) + " " + $currency + " - " + $("#slider-range1").slider("values", 1) + " " + $currency);
		
		
		//yacht size range implementation
		var rangeUnit = FmtMessage.getMessage('js.search.filter.yacht.meters');
		
		$("#slider-range2").slider({
			range: true,
			min: minSize,
			max: maxSize,
			values: [minSize, maxSize],
			step:SIZE_STEP_NUM,
			slide: function(event, ui) {
				$("#filterBySize").val(ui.values[0] + " " + rangeUnit + " - " + ui.values[1] + " " +  rangeUnit);
			}
		});
		$("#slider-range2").slider({change: function(event, ui) {
			applyFilter();
		}});
		$("#filterBySize").val($("#slider-range2").slider("values", 0) + " " + rangeUnit + " - " + $("#slider-range2").slider("values", 1) + " " + rangeUnit);
		
		//end yacht size implementation
		
		$("#yachtNameFilter").keyup(function() {
			applyFilter();
		});
		

	}
	
	var $yachtNameFilter = $("#yachtNameFilter");

	
	var getFilter = function(){
//		var yachtProperies = [];
//		$yachtProperties.each(function(index, item){
//			var isFilterItemSelected = $(item).prop("checked");
//			if(isFilterItemSelected){
//				yachtProperies.push(item.value);
//			}			
//		});
				
		return {
			minprice : $("#slider-range1").slider("values", 0),
			maxprice :  $("#slider-range1").slider("values", 1),
			minsize : $("#slider-range2").slider("values", 0),
			maxsize :  $("#slider-range2").slider("values", 1),
			name : $yachtNameFilter.val().toUpperCase()
		}
	};
		
	var applyFilter = function() {
		var filter = getFilter();
		for (var i in yachtList) {
			var yacht = yachtList[i];
			var show = isMatchesFilter(yacht, filter);
			if(show){
				yacht.$referance.show();
				yacht.$referance.attr("data-visible","true");
			}
			else{
				yacht.$referance.hide();
				yacht.$referance.attr("data-visible","false");
			}
		}
		$( document ).trigger( "yacht_filter_event");

	};
	
	var isMatchesFilter = function(yacht, filter){
		if(filter.name.length > 0 && yacht.name.indexOf(filter.name) < 0){
			return false;
		}		
				
		if(filter.minprice > yacht.price || filter.maxprice < yacht.price){
			return false;
		}
		
		if(filter.minsize > yacht.size || filter.maxsize < yacht.size){
			return false;
		}	
		
		//return false unless yacht properties match with all filter criterias.
//		if(yacht.properties){
//			yacht.properties += '';
//			var propertyList = yacht.properties.split(",");
//			for(var pIndex in filter.properties){
//				if($.inArray( filter.properties[pIndex], propertyList) == -1){
//					return false;
//				}
//			}
//		} else {
//			return false;
//		}
				
		return true;
	}
	
	
	return {
		init : init,
		applyFilter:applyFilter
	}
	
}();

var yachtSortFilter = function() {

	this.init = function (){
		
		$sortLabels.on('change', function(event){
	
			$("div.select-style.active").not(this)
				.removeClass("active").removeClass("desc");
			
			$("select.sortselect").not(this).val(0);
			
			var $this = $(this);
			var $option = $this.find(":selected");
			var attribute = $option.attr("data-filter-attribute");
			var direction = $option.attr("data-filter-direction");
			
			$this.parent().addClass("active");
			if (direction == 'desc') {
				$this.parent().addClass("dec");
			}else{
				$this.parent().removeClass("dec");
			}
			var valueType = $option.attr("data-filter-value-type");
			var yachtSortFunction = function(a, b) {
				var result;
				var valueA = $(a).data(attribute);
				var valueB = $(b).data(attribute);

				if (valueType == 'numeric') {
					valueA = parseFloat(valueA);
					valueB = parseFloat(valueB);
				}
				result = (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;
				if (direction == 'desc') {
					result *= -1;
				}
				return result;
			};

			$resultTable.sort(yachtSortFunction).appendTo("#yachtResultTable");

			$( document ).trigger( "yacht_filter_event");

		});

		
	}

	return {
		init : init
	}
	
}();